import { FC } from 'react';
import { Button } from 'react-daisyui';

type ApproveCarerModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  carerName: string;
  isLoading?: boolean;
};

const ApproveCarerModal: FC<ApproveCarerModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  carerName,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
        <h2 className="text-xl font-bold mb-4">Verify Application</h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to verify <span className="font-semibold">{carerName}</span>'s application?
        </p>
        <div className="flex gap-3 justify-end">
          <Button
            onClick={onClose}
            disabled={isLoading}
            className="bg-white text-black border border-gray-300 hover:bg-gray-50 rounded-lg"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-[#00A96E] text-white border-none hover:opacity-80 rounded-lg"
          >
            {isLoading ? 'Verifying...' : 'Verify'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApproveCarerModal;
